import React, { useState, useEffect } from 'react';

const C = { primary: '#0F6E56', gold: '#91600C', muted: '#94a3b8', danger: '#C0392B' };

function authHeaders() {
  const t = localStorage.getItem('token') || '';
  return { 'Content-Type': 'application/json', ...(t ? { Authorization: `Token ${t}` } : {}) };
}

/** Profile kitna mukammal hai. 100% par compact mode mein chhup jata hai. */
export default function ProfileCompletion({ user, compact }) {
  const [d, setD] = useState(null);

  useEffect(() => {
    if (!user) return;
    fetch('/api/my-completion/', { headers: authHeaders() })
      .then((r) => (r.ok ? r.json() : null))
      .then((j) => { if (j && !j.error) setD(j); })
      .catch(() => {});
  }, [user]);

  if (!user || !d) return null;
  if (d.percent >= 100 && compact) return null;

  const pct = d.percent;
  const color = pct >= 100 ? C.primary : pct >= 60 ? C.gold : C.danger;

  return (
    <div style={{
      background: 'rgba(255,255,255,0.07)', border: '1px solid rgba(255,255,255,0.15)',
      borderRadius: 10, padding: '9px 12px', margin: '10px 6px 0',
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 5 }}>
        <span style={{ fontSize: 12, fontWeight: 700, color: '#fff' }}>
          {'\u{1F464}'} Profile {pct}% complete
        </span>
        <span style={{ fontSize: 10.5, color: C.muted }}>{d.done}/{d.total}</span>
      </div>

      <div style={{ background: 'rgba(0,0,0,0.25)', borderRadius: 5, height: 7, overflow: 'hidden' }}>
        <div style={{ width: `${pct}%`, height: '100%', background: color, transition: 'width .4s' }} />
      </div>

      {d.next_step && (
        <a href={d.next_step.where || '/settings'}
           style={{ display: 'block', marginTop: 6, fontSize: 11, color: '#34d399', textDecoration: 'none' }}>
          Next: {d.next_step.icon} {d.next_step.label} — {d.next_step.why} {'\u2192'}
        </a>
      )}

      {!compact && d.missing.length > 0 && (
        <div style={{ marginTop: 8 }}>
          {d.missing.map((m) => (
            <a key={m.key} href={m.where || '/settings'}
               style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0',
                        fontSize: 11.5, color: '#e2e8f0', textDecoration: 'none',
                        borderBottom: '1px solid rgba(255,255,255,0.07)' }}>
              <span>{m.icon} {m.label}</span>
              <span style={{ color: C.muted, fontSize: 10 }}>{m.why}</span>
            </a>
          ))}
        </div>
      )}

      {pct < d.admin_min_completion && (
        <p style={{ margin: '6px 0 0', fontSize: 10, color: C.muted }}>
          {d.admin_min_completion}% needed to apply for an admin role.
        </p>
      )}
    </div>
  );
}
